import React, { useCallback, useEffect, useState } from 'react';
import { sharedState, } from '../../../store/rxjs/shared-state';
import { ERC20BridgeDialog } from '../ERC20BridgeDialog/ERC20BridgeDialog';
import { EmailNotificationSettingsDialog } from '../EmailNotificationSettingsDialog/EmailNotificationSettingsDialog';
export const SharedStateProvider = ({ children, }) => {
    const [erc20BridgeDialog, setErc20BridgeDialog] = useState(sharedState.get().erc20BridgeDialog);
    const [emailNotificationSettingsDialog, setEmailNotificationSettingsDialog] = useState(sharedState.get().emailNotificationSettingsDialog);
    useEffect(() => {
        const emailNotificationSettingsDialogSubscription = sharedState
            .select('emailNotificationSettingsDialog')
            .subscribe(setEmailNotificationSettingsDialog);
        return () => {
            emailNotificationSettingsDialogSubscription.unsubscribe();
        };
    }, []);
    useEffect(() => {
        const erc20BridgeDialogSubscription = sharedState
            .select('erc20BridgeDialog')
            .subscribe(setErc20BridgeDialog);
        return () => {
            erc20BridgeDialogSubscription.unsubscribe();
        };
    }, []);
    const handleEmailNotificationSettingsDialogClose = useCallback(() => sharedState.actions.closeEmailNotificationSettingsDialog(), []);
    const handleErc20BridgeDialogClose = useCallback(() => sharedState.actions.closeErc20BridgeDialog(), []);
    return (React.createElement(React.Fragment, null,
        children,
        React.createElement(EmailNotificationSettingsDialog, { isOpen: emailNotificationSettingsDialog.isOpen, onClose: handleEmailNotificationSettingsDialogClose }),
        React.createElement(ERC20BridgeDialog, { isOpen: erc20BridgeDialog.isOpen, onClose: handleErc20BridgeDialogClose, step: erc20BridgeDialog.step })));
};
